// import { Navigate } from "react-router-dom";
// import { useAuthStore } from "../store/auth.store";

// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = useAuthStore(
//     (state) => state.isAuthenticated
//   );

//   if (!isAuthenticated) {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;


import { Navigate } from "react-router-dom";
import { useAuthStore } from "../store/auth.store";
import { getFirstAllowedRoute } from "../utils/getFirstAllowedRoute";

const ProtectedRoute = ({ children, permission }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const hasPermission = useAuthStore((s) => s.hasPermission);
  const permissions = useAuthStore((s) => s.permissions);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Use hasPermission instead of permissions[permission] directly
  // so organizer overrides and parent-child logic in the store are respected
  if (permission && !hasPermission(permission)) {
    const fallback = getFirstAllowedRoute(permissions);
    return <Navigate to={`/dashboard${fallback}`} replace />;
  }

  return children;
};

export default ProtectedRoute;